export default [
    {
        path: '/admin/settings/youtube-videos',
        name:'videos',
        component:()=> import('@/views/pages/cloudx/settings/Videos.vue')
    },
    {
        path: '/admin/settings/additional-settings',
        name:'additional-settings',
        component:()=> import('@/views/pages/cloudx/settings/AdditionalSettings.vue')
    },
    {
        path: '/admin/settings/notification-category',
        name:'notification-category',
        component:()=> import('@/views/pages/cloudx/settings/NotificationCategory.vue')
    },
    {
        path: '/admin/settings/all-user-notification',
        name:'push-notification',
        component:()=> import('@/views/pages/cloudx/settings/PushAllUserNotification.vue')
    },
    {
        path: '/admin/settings/all-user-email',
        name:'push-email',
        component:()=> import('@/views/pages/cloudx/settings/PushAllUserEmail.vue')
    },
    {
        path: '/admin/settings/group-permission',
        name:'group-permission',
        component:()=> import('@/views/pages/cloudx/settings/GroupPermission.vue')
    },
    {
        path: '/admin/settings/group-permission/:id',
        component:()=> import('@/views/pages/cloudx/settings/PermissionsByGroup.vue')
    }
]